import { Checkbox, FormControlLabel } from "@mui/material";

export function SectionCheckBox({
  label,
  setChecked,
  checked,
  onChange,
  width,
  ...props
}) {
  const handleChange = (event) => {
    setChecked(event.target.checked);
  };
  return (
    <FormControlLabel
      sx={{
        "& .MuiButtonBase-root": { color: "var(--emr-darkblue) !important" },
        "& .MuiTypography-root": {
          fontSize: "13px",
          color: "var(--emr-primary-color-text)",
        },
      }}
      {...props}
      control={
        <Checkbox checked={checked} onChange={onChange || handleChange} />
      }
      label={label}
    />
  );
}
